function HomeProofSection() {
  return (
    <section className="proof" aria-label="Key statistics">
      <div className="wrap">
        <div className="proof-inner">
          <div className="proof-stat">
            <div className="proof-num">500+</div>
            <div className="proof-label">Professionals Trained</div>
          </div>
          <div className="proof-stat">
            <div className="proof-num">4.7<span className="star"></span></div>
            <div className="proof-label">Average Rating</div>
          </div>
          <div className="proof-stat">
            <div className="proof-num">8+</div>
            <div className="proof-label">Workshop Formats</div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default HomeProofSection;
